module.exports = __webpack_public_path__ + "static/img/serviceContent2.1a5c41c2.png";